import { Component, OnInit, ViewChild, Renderer } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { DocumentService } from '../../shared/web-api/document.service';
import { WorkflowService } from '../../shared/web-api/workflow.service';
import { TreeModule, TreeComponent, TreeNode, TreeModel } from 'angular-tree-component';
import { DropdownModule } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import { DialogModule } from 'primeng/primeng';
import { TabViewModule } from 'primeng/primeng';
import { TimeoutService } from '../../shared/service/timeout.service'
import { DataTableModule, SharedModule } from 'primeng/primeng';
import { BreadcrumbModule } from '../../shared/custom/breadcrumb/breadcrumb.module';
import { BreadcrumbComponent, Breadcrumb, TreeBreadcrumb } from '../../shared/custom/breadcrumb/breadcrumb.component';
import { SpinnerService } from '../../shell/spinner/spinner.service';
import { LanguageService } from '../../shell/language/language.service';
import { Translation, TranslationService, LocaleService, Localization } from 'angular-l10n';

@Component({
    selector: 'app-workflow-view',
    templateUrl: './workflow-view.component.html',
    styleUrls: ['./workflow-view.component.scss']
})
export class WorkflowViewComponent extends Localization implements OnInit {

    //#region Properties
    workflowId: number;
    nodeCode: number;
    treeHierarchy: app.models.TreeResult = <app.models.TreeResult>{ children: [] };
    prevNode: app.models.TreeResult = null;
    nextNode: app.models.TreeResult = null;

    firstLevelNodes: app.models.TreeResult[] = [];
    secondLevelNodes: app.models.TreeResult[] = [];
    //treeNodes: app.models.TreeResult[];
    selectedFistNodeDepth: number;

    secondLevelNodeId: number;
    firstLevelNodeId: number;

    workflowDescription: string;
    trimmedworkflowDescription: string;
    trimmedTextState: boolean = true;

    @ViewChild(TreeComponent)
    private tree: TreeComponent;

    //@ViewChild(TreeComponent)
    //private breadcrumbComponent: BreadcrumbComponent;
    @ViewChild("breadcrumbComponent") breadcrumbComponent: BreadcrumbComponent;

    selectedNode: TreeNode;
    selectedLanguage: app.models.LanguageModel;
    selectedNodeWithContent: app.models.WorkflowNodeResult;

    positionDiagram: any;

    selectedRootNodeContent: string;
    selectedRootNode: app.models.TreeResult;


    displayLegislation: boolean = false;
    displayDiagram: boolean = false;
    selectedPlaceholder: app.models.PlaceholderResult;
    langSubscription: Subscription;
    showHideMessage: boolean = true;


    //treeBreadcrumbNodes: app.models.
    treeBreadcrumbNodes: TreeBreadcrumb[];
    rowLevel: number = 0;
    //#endregion

    testing: string = `
        <app-image-map-viewer 
                (selectNode)="onSelectNode($event)"
                [width]="300" [height]="300" [model]="{displayName: 'Test', id: 1, documentId:101, areas: [{displayName: 'Area 1', coordinates: '162,166,458,252', targetWorkflowNodeCode:6 }]}">
        </app-image-map-viewer>`
    context = {
    };

    constructor(private route: ActivatedRoute,
        private router: Router,
        private documentService: DocumentService,
        private workflowService: WorkflowService,
        private spinnerService: SpinnerService,
        private languageService: LanguageService,
        private renderer: Renderer,
        private timeoutService: TimeoutService,
        private localization: LocaleService,
        public translation: TranslationService
    ) {
        super(localization, translation);
    }

    ngOnInit() {

        //alert('dsdsds');
        this.route.params.forEach((params: Params) => {
            this.nodeCode = +params['code'];
            this.workflowId = +params['workflowId'] || 0;
            this.loadData(false);

            //let nodeId = +params['nodeId'];
            ////this.workflowService.get
            //// alert(id);
            //this.workflowId = id;

            //if (nodeId) {
            //    // console.log(nodeId);
            //    this.loadDeepLinkNodeThatWorks(nodeId);
            //} else {
            //    this.loadFirstLevelNodes();
            //}
        });
        this.langSubscription = this.languageService.selectedLangauge.subscribe(x => {

            if (x.languageId != this.getSelectedLanguage()) {
                this.selectedLanguage = x;
                this.loadData(true);
            }

            //// console.log("in workflow view " + x.isoCode.toLowerCase());
            //this.selectedLanguage = x;
            //if (this.selectedNodeWithContent) {
            //    this.loadDeepLinkNodeThatWorks(this.selectedNodeWithContent.workflowNodeId, this.selectedNodeWithContent.nodeCode);
            //} else {
            //    if (this.rowLevel === 0) {
            //        this.loadFirstLevelNodes();
            //    } else {
            //        if (this.rowLevel === 1) {
            //            var selectedFirstRow = this.selectedRootNode;
            //            this.loadFirstLevelNodes();
            //            this.viewFirstNode(selectedFirstRow);
            //        }
            //    }

            //}
        });

    }

    ngOnDestroy() {
        this.langSubscription.unsubscribe();

        // We execute both functions to remove the respectives listeners

        // Removes "listen" listener
        // this.listenFunc();

        // Removs "listenGlobal" listener
    }

    loadData(forceReloadTree: boolean) {
        if (this.nodeCode) {
            this.loadNode(this.nodeCode);
        }

        if (!this.treeHierarchy.children.length || forceReloadTree) {
            this.loadTree(this.nodeCode);
        }
    }

    //#region Tree events and options

    // https://angular2-tree.readme.io/docs/events

    treeNodes: app.models.TreeResult[];


    treeoptions = {
    }

    loadPreviousNode(nodeInWfId: number) {
        this.prevNode = null;
        this.findPrevNodeInHierarchy(this.selectedNodeWithContent.nodeCode, this.treeHierarchy);
        if (!this.prevNode)
            return;

        this.gotoNode(this.prevNode.nodeCode);

        //let node = this.tree.treeModel.getNodeById(nodeInWfId);
        //if (!node) {
        //    this.loadPreviousSecondLevelNode();
        //    return;
        //}
        //let previousNode = node.findPreviousNode();
        //if (!previousNode) {
        //    this.viewSecondNode(this.secondLevelNodes.find(x => x.nodeId == this.secondLevelNodeId));
        //    return;
        //}
        //this.loadNodeWithCorrectStyle(previousNode.id, previousNode.data.nodeCode);

    }

    loadNextNode(nodeInWfId: number) {

        this.nextNode = null;
        this.findNextNodeInHierarchy(this.selectedNodeWithContent.nodeCode, this.treeHierarchy);
        if (!this.nextNode)
            return;

        this.gotoNode(this.nextNode.nodeCode);


        //let node = this.tree.treeModel.getNodeById(nodeInWfId);
        //if (!node) {
        //    if (this.tree.treeModel.roots.length) {
        //        this.loadNodeWithCorrectStyle(this.tree.treeModel.roots[0].id, this.tree.treeModel.roots[0].data.nodeCode);
        //        return;
        //    }
        //    this.loadNextSecondLevelNode();
        //    return;
        //}
        //let nextNode = node.findNextNode();
        //if (!nextNode) {
        //    this.loadNextSecondLevelNode();
        //    return;
        //}
        //this.loadNodeWithCorrectStyle(nextNode.id, nextNode.data.nodeCode);

    }

    //loadNextSecondLevelNode() {
    //    let secondLevelNodeIndex = this.secondLevelNodes.findIndex(x => x.nodeId == this.secondLevelNodeId);
    //    if (secondLevelNodeIndex == undefined || this.secondLevelNodes.length <= secondLevelNodeIndex + 1) {
    //        this.loadNextFirstLevelNode();
    //        return;
    //    }

    //    this.viewSecondNode(this.secondLevelNodes[secondLevelNodeIndex + 1]);
    //}

    //loadNextFirstLevelNode() {
    //    let firstLeveleNodeIndex = this.firstLevelNodes.findIndex(x => x.nodeId == this.firstLevelNodeId);
    //    if (firstLeveleNodeIndex == undefined || this.firstLevelNodes.length <= firstLeveleNodeIndex + 1) {
    //        return;
    //    }

    //    this.viewFirstNode(this.firstLevelNodes[firstLeveleNodeIndex + 1]);
    //}

    //loadPreviousSecondLevelNode() {
    //    let secondLevelNodeIndex = this.secondLevelNodes.findIndex(x => x.nodeId == this.secondLevelNodeId);
    //    if (secondLevelNodeIndex == undefined || secondLevelNodeIndex <= 0) {
    //        this.loadPreviousFirstLevelNode();
    //        return;
    //    }

    //    this.viewSecondNode(this.secondLevelNodes[secondLevelNodeIndex - 1], true);
    //}

    //loadPreviousFirstLevelNode() {
    //    let firstLeveleNodeIndex = this.firstLevelNodes.findIndex(x => x.nodeId == this.firstLevelNodeId);
    //    if (firstLeveleNodeIndex == undefined || firstLeveleNodeIndex <= 0) {
    //        this.viewFirstNode(this.firstLevelNodes[0]);
    //        return;
    //    }

    //    this.viewFirstNode(this.firstLevelNodes[firstLeveleNodeIndex - 1]);
    //}


    //getBreadcrumbs() {
    //    return "breadcrumbs";
    //}

    //onToggle($event) {
    //    // console.log($event);
    //}

    //onActiveChanged($event) {
    //    // console.log($event);
    //}

    //onBlur($event) {
    //    // console.log($event);
    //}

    onFocus($event) {
        if (this.selectedNode == $event.node) {
            return;
        }

        this.selectedNode = $event.node;
        this.gotoNode(this.selectedNode.data.nodeCode);
    }


    //#endregion

    //viewNode() {
    //    // alert('ok');
    //}

    viewFirstNode(node: app.models.TreeResult) {
        //this.router.navigateByUrl(`/workflows/view/${node.nodeCode}`);
        this.gotoNode(node.nodeCode);

        //console.log(node);
        //this.selectedRootNodeContent = node.content;
        //this.selectedRootNode = node;
        //this.rowLevel = 1;
        //this.firstLevelNodeId = node.nodeId;
        //var languageId = this.getSelectedLanguage();
        //var model: app.models.ViewWorkflowModel =
        //    {
        //        workflowId: this.workflowId,
        //        parentId: node.nodeId,
        //        parentCode: node.nodeCode,
        //        languageId: languageId,
        //        bringSecondLevelChildren: false,
        //        loadContent: true
        //    };
        //this.workflowService.viewWorkflow(model)
        //    .subscribe(result => {
        //        //console.log(result);
        //        //result.data.items.forEach(n => {
        //        //    n.name = n.numbering + n.name;
        //        //});
        //        this.secondLevelNodes = result.data.items;
        //        //this.rootNode = result.data;
        //        //this.nodes = result.data.items;
        //    });
    }

    shoudArrowBeVisible(node: app.models.TreeResult) {
        return node.nodeId === this.selectedRootNode.nodeId;
    }

    shoudSelected(node: app.models.PositionInDiagramModel) {
        return false;
    }

    showDiagram(positionModel: app.models.PositionInDiagramModel) {
        this.displayDiagram = true;
        // this.selectedNodeWithContent.workflowNodeId
    }

    hideDiagram() {
        this.displayDiagram = false;
    }

    loadTree(nodeCode) {
        var languageId = this.getSelectedLanguage();
        var model: app.models.ViewWorkflowModel =
        {
            workflowId: this.workflowId,
            parentId: 0,
            parentCode: null,
            languageId: languageId,
            bringSecondLevelChildren: true,
            loadContent: false
        };

        this.workflowService.viewWorkflow(model)
            .subscribe(result => {
                this.treeHierarchy.children = result.data.items;

                if (!this.nodeCode) {
                    this.workflowService.getWorkflowDescription(model)
                        .subscribe(result => {
                            this.workflowDescription = result.data;
                            if (this.workflowDescription)
                                this.trimDescription(this.workflowDescription);
                        });
                }

                this.setNavigation(nodeCode);
            });
    }

    toggleTrimmedText() {
        var showLess = document.getElementById("showLess");
        var showMore = document.getElementById("showMore");
        if (this.trimmedTextState) {
            this.trimmedTextState = false;
            showMore.style.display = "none";
            showLess.style.display = "block";
        } else {
            this.trimmedTextState = true;
            showMore.style.display = "block";
            showLess.style.display = "none";
        }

    }

    trimDescription(description: string) {
        var maxLength = 2000;
        var trimmedString = description.substr(0, maxLength);
        this.trimmedworkflowDescription = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
    }

    viewSecondNode(node: app.models.TreeResult, selectLastChild: boolean = false) {
        this.gotoNode(node.nodeCode);
        /*this.rowLevel = 2;
        // console.log("in load second node");
        var languageId = this.getSelectedLanguage();
        var model: app.models.ViewWorkflowModel =
            {
                workflowId: this.workflowId,
                parentId: node.nodeId,
                parentCode: node.nodeCode,
                languageId: languageId,
                bringSecondLevelChildren: true,
                loadContent: true
            };
        this.loadNode(node.nodeCode);
        this.secondLevelNodeId = node.nodeId;
        this.workflowService.viewWorkflow(model)
            .subscribe(result => {
                // console.log(result);
                //result.data.items.forEach(n => {
                //    n.name = n.numbering + n.name;
                //});
                console.log("second level");
                this.treeNodes = result.data.items;
                this.timeoutService.timeout(() => {
                    if (!this.tree.treeModel || !this.tree.treeModel.roots) {
                        return;
                    }

                    for (let node of this.tree.treeModel.roots) {
                        node.expand();
                    }
                    this.tree.treeModel.setFocusedNode(null);
                    this.tree.treeModel.setActiveNode(null, null);

                    if (selectLastChild && this.tree.treeModel.roots && this.tree.treeModel.roots.length) {
                        var lastNode = this.tree.treeModel.getLastRoot().getLastChild();
                        if (lastNode) {
                            this.loadNodeWithCorrectStyle(lastNode.data.nodeInWfId, lastNode.data.nodeCode);
                            return;
                        }
                    }
                }, 0.25).subscribe();
                window.scrollTo(0, 0);
                //this.rootNode = result.data;
                //this.nodes = result.data.items;
            });*/
    }

    //loadNodeWithCorrectStyle(nodeInWfId: number, nodeCode: number) {
    //    this.tree.treeModel.setFocusedNode(null);
    //    this.tree.treeModel.setActiveNode(null, null);
    //    // console.log(id + " = todo to load node based on id");
    //    let firstLevelNode = this.firstLevelNodes.filter(item => +item.id === +nodeInWfId);

    //    if (firstLevelNode && firstLevelNode.length > 0) {
    //        this.loadDeepLinkNodeThatWorks(nodeInWfId, nodeCode);
    //        return;
    //    }
    //    let secondLevelNode = this.secondLevelNodes.filter(item => +item.id === +nodeInWfId);

    //    if (secondLevelNode && secondLevelNode.length > 0) {
    //        this.loadDeepLinkNodeThatWorks(nodeInWfId, nodeCode);
    //        return;
    //    }


    //    var node2 = this.searchNode(this.tree.treeModel.nodes, nodeInWfId);

    //    if (node2) {
    //        this.tree.treeModel.setFocusedNode(null);
    //        this.tree.treeModel.setActiveNode(null, null);
    //        var node = this.tree.treeModel.getNodeById(node2.id);
    //        if (node) {
    //            this.tree.treeModel.setActiveNode(node, true);
    //            node.focus();
    //            return;
    //        }
    //    }

    //    //this.loadDeepLinkNodeThatWorks(nodeInWfId, nodeCode);

    //    //var node = this.tree.treeModel.getNodeById(id);
    //    //console.log("node");
    //    //console.log(node);
    //    //if (node) {
    //    //    console.log(node);
    //    //    this.loadNode(node.nodeId, true);
    //    //}
    //}
    //selectedIdFromBreadcrumChanged(event) {
    //    let id = event.value;
    //    this.loadNodeWithCorrectStyle(id, null);
    //}

    //searchNode(nodes: TreeNode[], nodeInWfId: number) {
    //    // console.log(nodes);
    //    if (!nodes || nodes.length === 0)
    //        return null;
    //    var retval = null;
    //    for (let i = 0; i < nodes.length; i++) {

    //        let node = nodes[i];
    //        // console.log("caut in ");

    //        let id1 = +node.id || -1;
    //        let id2 = +nodeInWfId;
    //        // console.log(id1 + " " + id2);
    //        if (id1 === id2) {
    //            // alert('bingo');
    //            return node;
    //        }

    //        //if (node.children && node.children.length > 0)
    //        retval = this.searchNode(node.children, nodeInWfId);
    //        if (retval != null)
    //            return retval;
    //    }
    //    return retval;
    //}

    showDocument(doc: app.models.DocumentSearchResult) {
        //alert('todo');
        this.documentService.download(doc.id).subscribe();

        //this.documentService.download(doc.id)
        //    .subscribe(data => window.open(window.URL.createObjectURL(data)),
        //    error => console.log("Error downloading the file." + error),
        //    () => console.log('Completed file download.'));



    }

    showPlaceholder(placeholder: app.models.PlaceholderResult) {
        this.selectedPlaceholder = placeholder;
        this.displayLegislation = true;
    }

    hidePlaceholder() {
        this.displayLegislation = false;
        this.selectedPlaceholder = null;
    }


    getSelectedLanguage() {
        let languageId = 1;
        if (this.selectedLanguage) {
            // console.log(this.selectedLanguage);
            //console.log(this.selectedLanguage.value);
            languageId = this.selectedLanguage.languageId;
        }
        return languageId;
    }

    //#region Nodes management

    loadBreadcrumbs(nodeId: number): app.models.PagedResultViewModel<app.models.WorkflowNodeBreadbrumbResult> {

        return null;
        //var result: app.models.PagedResultViewModel<app.models.WorkflowNodeBreadbrumbResult> = {
        //    items: [],
        //    pageNumber: 0,
        //    pageSize: 10,
        //    totalCount: 0
        //};
        //var rootNodeBreadCrumb: app.models.WorkflowNodeBreadbrumbResult = {
        //    level: 0,
        //    parentId: null,
        //    title: this.selectedRootNode.name,
        //    workflowNodeId: this.selectedRootNode.nodeId
        //};
        //result.items.push(rootNodeBreadCrumb);

        //let secondLevelNode = this.secondLevelNodes.filter(item => +item.nodeId === +this.secondLevelNodeId)[0];

        //let secondLevelNodeBreadCrumb: app.models.WorkflowNodeBreadbrumbResult = {
        //    level: 0,
        //    parentId: rootNodeBreadCrumb.workflowNodeId,
        //    title: secondLevelNode.name,
        //    workflowNodeId: secondLevelNode.nodeId
        //};
        //result.items.push(secondLevelNodeBreadCrumb);

        //let currentNode = this.tree.treeModel.getNodeById(nodeId);
        //if (!currentNode)
        //    return result;
        //let node = this.tree.treeModel.getNodeById(currentNode.data.parentId);

        //while (node != null) {
        //    // this.tree.treeModel.
        //    let nodeBreadcrumb: app.models.WorkflowNodeBreadbrumbResult = {
        //        level: 0,
        //        parentId: node.workflowNodeId,
        //        title: node.data.name,
        //        workflowNodeId: node.nodeId
        //    };
        //    result.items.push(nodeBreadcrumb);
        //    node = this.tree.treeModel.getNodeById(node.data.parentId);
        //}
        //console.log(result);
        //return result;
        //// this.selectedNodeWithContent.breadcrumbs = result;
    }

    gotoNode(nodeCode: number) {
        if (this.workflowId) {
            this.router.navigateByUrl(`/workflows/view/${this.workflowId}/${nodeCode}`);
        }
        else {
            this.router.navigateByUrl(`/workflows/view/${nodeCode}`);
        }
    }

    loadNode(nodeCode: number, loadBreadcrumbs: boolean = true) {
        // alert('dsds');
        // alert(this.selectedNode.nodeId);
        //alert('dsds2');
        var languageId = this.getSelectedLanguage();
        let model: app.models.WorkflowNodeInLanguageSearchModel =
            <app.models.WorkflowNodeInLanguageSearchModel>{
                languageId: languageId,
                nodeCode: nodeCode,
                workflowId: this.workflowId
            };
        //this.spinnerService.start();
        return this.workflowService.getWorkflowNodeInLanguage(model)
            .subscribe(result => {
                // console.log(result.data);
                this.selectedNodeWithContent = result.data;
                // this.tree.treeModel.setActiveNode(this.selectedNode, true);
                // this.tree.treeModel.setFocusedNode(this.selectedNode);
                if (!this.selectedNodeWithContent.positionInDiagram) {
                    this.selectedNodeWithContent.positionInDiagram = <app.models.PositionInDiagramModel>{};
                }

                this.setNavigation(this.selectedNodeWithContent.nodeCode)
                if (this.rowLevel == 1) {
                    this.selectedRootNode.content = this.selectedNodeWithContent.content;
                }

                window.scrollTo(0, 0)

                //if (loadBreadcrumbs) {
                //    var bb = this.loadBreadcrumbs(this.selectedNodeWithContent.workflowNodeId);
                //    this.selectedNodeWithContent.breadcrumbs = bb;
                //    this.treeBreadcrumbNodes = [];
                //    bb.items.forEach(t => {
                //        var breadcrumb = <TreeBreadcrumb>{
                //            label: t.title,
                //            url: "",
                //            routePattern: "",
                //            id: t.workflowNodeId + "",
                //        };
                //        this.treeBreadcrumbNodes.push(breadcrumb);
                //    });
                //}
                //window.scrollTo(0, 0);

                // console.log("position in diagram");
                // console.log(this.selectedNodeWithContent.positionInDiagram);
                //console.log("anchors");
                //console.log(this.selectedNodeWithContent.anchors["1"]);
                //this.positionDiagram = this.selectedNodeWithContent.anchors["1"];
                //this.positionDiagram.nodeId = this.selectedNodeWithContent.anchors["1"].anchorId;

                //this.spinnerService.stop();
            });

        //if (!loadBreadcrumbs)
        //    return;

        //var bb = this.loadBreadcrumbs(nodeId);
        //this.selectedNodeWithContent.breadcrumbs = bb;
        //this.treeBreadcrumbNodes = [];
        //bb.items.forEach(t => {
        //    var breadcrumb = {
        //        label: t.title,
        //        url: "",
        //        routePattern: "",
        //        id: t.workflowNodeId + ""
        //    };
        //    this.treeBreadcrumbNodes.push(breadcrumb);
        //});

        /*
        var breadcrumbModel: app.models.BreadcrumbModel =
            {
                workflowId: this.workflowId,
                nodeId: nodeId,
                languageId: languageId
            };
        this.workflowService.getWorkflowNodePath(breadcrumbModel)
            .subscribe(result => {
                // console.log(result.data.items);
                this.treeBreadcrumbNodes = [];
                result.data.items.forEach(t => {
                    var breadcrumb = {
                        label: t.title,
                        url: "",
                        routePattern: "",
                        id: t.workflowNodeId + ""
                    };
                    this.treeBreadcrumbNodes.push(breadcrumb);
                });
            });
        */
        //this.testing = this.testing + "x";
        //this.treeBreadcrumbNodes.push(rootNode);
        //this.treeBreadcrumbNodes.push(tb2);
        //this.breadcrumbComponent.treeBreadcrumbNodes = this.treeBreadcrumbNodes;

        //for (let node of this.tree.treeModel.roots) {
        //    node.expand();
        //}
    }

    setNavigation(nodeCode: number) {
		this.treeNodes = [];
        if (!this.treeHierarchy.children.length)
            return;

        var nodeInHierarchy = this.findNodeInHierarchy(nodeCode, this.treeHierarchy);

        this.rowLevel = nodeInHierarchy.length;
        this.firstLevelNodes = this.treeHierarchy.children;
        this.treeBreadcrumbNodes = [];
        if (this.treeBreadcrumbNodes.length == 0)
            this.treeBreadcrumbNodes.push({ label: "GHID", url: '/workflows/view/', id: undefined, params: {}, routePattern: undefined })
        this.nextNode = null;
        this.prevNode = null;

        if (!nodeInHierarchy.length)
            return;

        this.selectedRootNode = nodeInHierarchy[0];
        this.firstLevelNodeId = nodeInHierarchy[0].id;
        this.secondLevelNodes = nodeInHierarchy[0].children;

        if (this.rowLevel >= 2) {
            this.secondLevelNodeId = nodeInHierarchy[1].id;

            let treeChanged = this.treeNodes != nodeInHierarchy[1].children;
            this.treeNodes = nodeInHierarchy[1].children;
            this.setTreeActiveStyles(nodeInHierarchy[nodeInHierarchy.length - 1].id, treeChanged);
        }


        for (let node of nodeInHierarchy) {
            if (this.workflowId) {
                this.treeBreadcrumbNodes.push({ label: node.name, url: `/workflows/view/${this.workflowId}/${node.nodeCode}`, id: undefined, params: {}, routePattern: undefined })
            }
            else {
                this.treeBreadcrumbNodes.push({ label: node.name, url: `/workflows/view/${node.nodeCode}`, id: undefined, params: {}, routePattern: undefined })
            }
        }
    }

    findNodeInHierarchy(nodeCode: number, parent: app.models.TreeResult): app.models.TreeResult[] {
        for (let node of parent.children) {
            if (node.nodeCode == nodeCode) {
                return [node];
            }
            let found = this.findNodeInHierarchy(nodeCode, node);
            if (found.length)
                return [node, ...found];
        }
        return [];
    }

    findNextNodeInHierarchy(nodeCode: number, node: app.models.TreeResult): boolean {

        let nextNodeReturn: boolean = false;

        if (this.nextNode) {
            return false;
        }

        if (node.nodeCode == nodeCode) {
            nextNodeReturn = true;
        }

        for (let child of node.children) {
            if (nextNodeReturn) {
                this.nextNode = child;
                return false;
            }
            nextNodeReturn = this.findNextNodeInHierarchy(nodeCode, child);
        }
        return nextNodeReturn;
    }

    findPrevNodeInHierarchy(nodeCode: number, node: app.models.TreeResult, nextNodeReturn: boolean = false): boolean {
        if (this.prevNode) {
            return false;
        }

        for (let i: number = node.children.length - 1; i >= 0; i--) {
            let child = node.children[i];

            nextNodeReturn = this.findPrevNodeInHierarchy(nodeCode, child, nextNodeReturn);
        }

        if (nextNodeReturn) {
            this.prevNode = node;
            return false;
        }

        if (node.nodeCode == nodeCode) {
            nextNodeReturn = true;
        }

        return nextNodeReturn;
    }

    toggleNavigation() {
        var sideBarDiv = document.getElementById("navigationTreeMenuContent");
        if (sideBarDiv.style.display === "none") {
            sideBarDiv.style.display = "block";
            this.showHideMessage = true;
        } else /*if (document.getElementById("matrixContent").style.display !== "none")*/ {
            sideBarDiv.style.display = "none";
            this.showHideMessage = false;
        }
    }




    //loadDeepLinkNodeThatWorks(nodeInWfId, nodeCode) {
    //    var languageId = this.getSelectedLanguage();
    //    var breadcrumbModel: app.models.BreadcrumbModel =
    //        {
    //            workflowId: this.workflowId,
    //            nodeId: undefined,
    //            nodeCode: nodeCode,
    //            languageId: languageId
    //        };
    //    this.workflowService.getWorkflowNodeDeep(breadcrumbModel)
    //        .subscribe(res => {
    //            // console.log(res.data);
    //            var deepLinkResult: app.models.WorkflowNodeDeepResult = res.data;
    //            this.rowLevel = deepLinkResult.level;
    //            this.firstLevelNodes = deepLinkResult.firstLevelNodes.items;
    //            this.secondLevelNodes = deepLinkResult.secondLevelNodes.items;
    //            this.selectedRootNodeContent = deepLinkResult.rootNode.content;
    //            this.selectedRootNode = deepLinkResult.rootNode;

    //            this.treeNodes = deepLinkResult.treeNodes.items;

    //            this.timeoutService.timeout(() => {
    //                if (!this.tree.treeModel || !this.tree.treeModel.roots) {
    //                    return;
    //                }
    //                for (let node of this.tree.treeModel.roots) {
    //                    node.expand();
    //                }

    //                this.tree.treeModel.setFocusedNode(null);
    //                this.tree.treeModel.setActiveNode(null, null);
    //                var node = this.tree.treeModel.getNodeById(nodeInWfId);
    //                if (node) {
    //                    this.tree.treeModel.setActiveNode(node, true);
    //                    node.focus();                        
    //                }
    //            }, 0.25).subscribe();

    //            this.workflowDescription = deepLinkResult.worflowDescription;
    //            this.treeBreadcrumbNodes = [];

    //            if (deepLinkResult.breadcrumbs.items.length)
    //                this.firstLevelNodeId = deepLinkResult.breadcrumbs.items[0].workflowNodeId;

    //            if (deepLinkResult.breadcrumbs.items.length > 1)
    //                this.secondLevelNodeId = deepLinkResult.breadcrumbs.items[1].workflowNodeId;

    //            deepLinkResult.breadcrumbs.items.forEach(t => {
    //                var breadcrumb = <TreeBreadcrumb>{
    //                    label: t.title,
    //                    url: "",
    //                    routePattern: "",
    //                    id: t.workflowNodeId + ""
    //                };
    //                this.treeBreadcrumbNodes.push(breadcrumb);
    //            });
    //            this.loadNode(nodeCode, false);
    //            window.scrollTo(0, 0);
    //            //this.treeBreadcrumbNodes = deepLinkResult.breadcrumbs.items;

    //        });
    //}

    private setTreeActiveStyles(nodeInWfId: number, treeChanged: boolean) {

        let activateTree = () => {
            if (!this.tree || !this.tree.treeModel) {
                return;
            }

            var activeNode = this.tree.treeModel.getActiveNode();
            if (activeNode && activeNode.id == nodeInWfId) {
                return;
            }

            this.tree.treeModel.setFocusedNode(null);
            this.tree.treeModel.setActiveNode(null, null);
            var node = this.tree.treeModel.getNodeById(nodeInWfId);
            if (node) {
                this.tree.treeModel.setActiveNode(node, true);
                node.focus();
            }
        }

        if (treeChanged) {
            setTimeout(() => {
                if (!this.tree || !this.tree.treeModel || !this.tree.treeModel.roots) {
                    return;
                }
                for (let node of this.tree.treeModel.roots) {
                    node.expand();
                }
                activateTree();
            }, 250);
        }
        else {
            activateTree();
        }
    }


    //public loadFirstLevelNodes<TResult>(): Observable<TResult> {
    //    var source = Observable.create(observer => {
    //        var languageId = this.getSelectedLanguage();
    //        console.log("in load first level nodes " + this.workflowId);
    //        //console.log(id);
    //        var model: app.models.ViewWorkflowModel =
    //            {
    //                workflowId: this.workflowId,
    //                parentId: 0,
    //                languageId: languageId,
    //                bringSecondLevelChildren: false
    //            };
    //        console.log("dupa model cstrl");
    //        this.workflowService.viewWorkflow(model)
    //            .subscribe(result => {
    //                console.log(result);
    //                console.log("in 1 level load nodes...");
    //                this.firstLevelNodes = result.data.items;
    //                //this.rootNode = result.data;
    //                //this.nodes = result.data.items;
    //            });


    //        // Any cleanup logic might go here
    //        return () => console.log('disposed');
    //    });

    //    return source;

    //}


    //loadFirstLevelNodes() {
    //    var languageId = this.getSelectedLanguage();
    //    // console.log("in load first level nodes " + this.workflowId);
    //    //console.log(id);
    //    var model: app.models.ViewWorkflowModel =
    //        {
    //            workflowId: this.workflowId,
    //            parentId: 0,
    //            parentCode: null,
    //            languageId: languageId,
    //            bringSecondLevelChildren: false,
    //            loadContent: false
    //        };
    //    this.workflowService.viewWorkflow(model)
    //        .subscribe(result => {
    //            // console.log(result);
    //            // console.log("in 1 level load nodes...");
    //            //result.data.items.forEach(n => {
    //            //    n.name = n.numbering + n.name;
    //            //});
    //            this.firstLevelNodes = result.data.items;
    //            this.workflowService.getWorkflowDescription(model)
    //                .subscribe(result => {
    //                    // console.log(result.data);
    //                    this.workflowDescription = result.data;
    //                });
    //            //this.rootNode = result.data;
    //            //this.nodes = result.data.items;
    //        });

    //}




}



// WEBPACK FOOTER //
// ./src/app/workflows/workflow-view/workflow-view.component.ts